import axios from 'axios';
import { Message, MessageBox } from 'element-ui';
import useSession from '@/utils/session';
import { successplugIin, errorplugIin, warningplugIin, warnnotification } from "@/utils/information";
import { storageName } from "@/utils/storageName";

const switchApi = (type = 1) => type === 1 ? 'https://apiaws.ailifeus.com/' : 'https://apiaws2.ailifeus.com/';

// 创建 axios 实例
const service = axios.create({
  timeout: 30000,
  retryDelay: 2000, // 请求间隔
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    config.baseURL = switchApi(config.requestBaseUrl);
    const token = useSession.getStorage(storageName.TokenName);
    if (token) config.headers.Authorization = token;
    return config;
  },
  error => Promise.reject(error)
);

// 响应拦截器
service.interceptors.response.use(
  res => {
    const errorMap = {
      1001: () => { /* token 无效逻辑 */ },
      3001: () => errorplugIin('Request timeout'),
      4001: () => errorplugIin('Request timeout'),
      4002: () => errorplugIin('IP change detected, please log in again'),
      1006: () => errorplugIin('Request timeout'),
      2001: () => errorplugIin('Database error')
    };
    if (res.data && res.data.error && errorMap[res.data.error]) {
      errorMap[res.data.error]();
    }
    return res;
  },
  error => {
    errorplugIin('Network or server error');
    return Promise.reject(error);
  }
);

// 通用请求方法工厂
const createHttpMethod = (method, defaultHeaders = {}) => (param, type = 1, headers = {}) => {
  const options = {
    url: param.url,
    method,
    requestBaseUrl: type,
    headers: { ...defaultHeaders, ...headers }
  };
  if (method === 'GET') options.params = param.data;
  else options.data = param.data;

  return service(options);
};

// 导出封装好的方法
export const httpPost = createHttpMethod('POST', { 'Content-Type': 'application/json; charset=UTF-8' });
export const httpGet = createHttpMethod('GET', { 'Content-Type': 'application/json; charset=UTF-8' });
export const httpPut = createHttpMethod('PUT', { 'Content-Type': 'application/json; charset=UTF-8' });
export const httpDelete = createHttpMethod('DELETE');


// WEBPACK FOOTER //
// ./src/utils/request.js